import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import { DocumentFolder } from "../../../data/Document/models";
import { ChevronRight, ExpandMore, FolderOutlined } from "@mui/icons-material";
import DownloadbleFile from "./DownloadableFile";

type Props = {
  folder: DocumentFolder;
  level: number;
};

const folderStyles = {
  button: {
    cursor: "pointer",
    background: "#f1f1f1",
    userSelect: "none",
    "&:hover": {
      background: "lightgray",
    },
  },
};

export const fileStyles = {
  button: {
    background: "#f1f1f1",
    userSelect: "none",
  },
};
const ExpandableFolder = ({ folder, level }: Props) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");

  return (
    <Box display="grid" gap="2px" color="icon.solidColor">
      <Box
        display="flex"
        flexDirection="row"
        gap="8px"
        onClick={() => setOpen(!open)}
        sx={{ ...folderStyles.button }}
      >
        {open ? <ExpandMore /> : <ChevronRight />}
        <FolderOutlined/>
        <Typography>{folder.name}</Typography>
      </Box>
      <Collapse
        in={open}
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: `${level + 1 * 16}px`,
        }}
      >
        {folder.files.map((file, index) => {
          if (file.type === "folder") {
            return (
              <ExpandableFolder folder={file} level={level + 1} key={file.id + index} />
            );
          } else {
            return <Box sx={{ ...fileStyles.button }} key={file.id + index} paddingLeft={"2rem"}><DownloadbleFile file={file}/></Box>;
          }
        })}
      </Collapse>
    </Box>
  );
};

export default ExpandableFolder;
